import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NonUniqueBankAccountNumberWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.client.validation.non-unique-bank-account-number-warning.message');
    }
}
